/**
 * theme
 */
export default {
  namespaced: true,
  state: {
    theme: false
  },
  
  mutations: {
    SET_IS_INIT_THEME (state) {
      state.theme = true
    }
  },
  getters: {
    isInitTheme: (state) => state.theme
  }
}
